import { useEffect, useRef } from "react";

export function useDebouncedCallback<TArgs extends unknown[]>(
  callback: (...args: TArgs) => void,
  delayMs: number,
) {
  const latest = useRef(callback);
  latest.current = callback;

  const timeout = useRef<ReturnType<typeof setTimeout>>(undefined);

  useEffect(() => () => clearTimeout(timeout.current), []);

  return (...args: TArgs) => {
    clearTimeout(timeout.current);
    timeout.current = setTimeout(() => latest.current(...args), delayMs);
  };
}
